<div class="dialog-box card p-3">
  @if (selectedPagePrompts?.length) {
    @for (field of selectedPagePrompts; track field) {
      <div class="p-1">
        <dl>
          <ng-template
            *ngTemplateOutlet="formTemplate; context: { value: field }"
          ></ng-template>
        </dl>
      </div>
    }
  }
  <ng-container>
    <span class="text-danger mb-2 d-none"
      >Fields marked * cannot be empty
    </span>
    <div [ngClass]="page > 0 ? 'row row-cols-3 py-3' : 'row row-cols-2 py-3'">
      @if (page > 0) {
        <div class="col">
          <button
            [disabled]="page === 0"
            (click)="changePagination(false)"
            class="btn btn-dark w-100 btn-lg"
          >
            Back
          </button>
        </div>
      }
      <div class="col">
        <button class="btn btn-dark btn-lg w-100" (click)="closeDalog(false)">
          Cancel
        </button>
      </div>
      @if (preview) {
        <div class="col">
          <button
            class="btn btn-primary w-100 btn-lg"
            [disabled]="
              page + 1 < promptData?.length ? validatepage() : valdiateForm()
            "
            (click)="
              page + 1 < promptData?.length ? changePagination() : closeDalog()
            "
          >
            {{ page + 1 < promptData?.length ? "Next" : "OK" }}
          </button>
        </div>
      }
      @if (!preview) {
        <div class="col">
          <button
            class="btn btn-primary w-100 btn-lg"
            [disabled]="
              page + 1 < promptData?.length ? validatepage() : valdiateForm()
            "
            (click)="
              page + 1 < promptData?.length
                ? changePagination()
                : savePromtData()
            "
          >
            {{ page + 1 < promptData?.length ? "Next" : "OK" }}
          </button>
        </div>
      }
    </div>
  </ng-container>
</div>
<ng-template let-field="value" #formTemplate>
  @if (field.type === "output") {
    @if (field.description) {
      <div class="field-output-description fw-semibold">
        {{ field.description }}
        @if (field?.required) {
          <span class="text-danger">*</span>
        }
      </div>
    }
  }
  @if (field.type === "input") {
    @if (field.description) {
      <div class="field-input-description">
        {{ field.description }}
        @if (field?.required) {
          <span class="text-danger">*</span>
        }
      </div>
    }
    <div>
      @switch (field.field) {
        @case ("text") {
          <textarea
            rows="1"
            class="form-control"
            [required]="field?.required"
            [(ngModel)]="field.value"
          ></textarea>
        }
        @case ("photo") {
          <div class="p-1 d-flex">
            @if (field?.fileUrl) {
              <img
                src="{{ field?.fileUrl }}"
                height="120"
                width="120"
                class="small-img-preview"
              />
              <div class="p-2 d-flex justify-content-between flex-column gap-2">
                <div
                  class="bg-body-secondary text-body-emphasis rounded border border-secondary px-3 py-2 d-flex justify-content-center align-items-center"
                  (click)="onOpenFile(field)"
                >
                  <i class="fa-solid fa-magnifying-glass fs-5 text-primary"></i>
                </div>
                @if (field?.status == "Success") {
                  <div
                    (click)="removeFileFromPrompt(field)"
                    class="bg-body-secondary text-body-emphasis rounded border border-secondary px-3 py-2 d-flex justify-content-center align-items-center"
                  >
                    <i class="text-danger fa-solid fa-circle-minus fs-5"></i>
                  </div>
                }
              </div>
            } @else {
              <div
                (click)="openCamPopup(field)"
                class="bg-body-secondary text-body-emphasis rounded border border-secondary px-3 py-2 text-center"
                role="button"
              >
                <i class="fa-solid fa-camera fs-5"></i>
                <div>Take Photo</div>
              </div>
            }
          </div>
          @if (field?.status == "Uploading") {
            <div class="justify-content-end d-flex align-items-center gap-2">
              <div>Processing Image</div>
              <div
                class="spinner-border text-dark spinner-border-sm"
                role="status"
              ></div>
            </div>
          }
        }
        @case ("checkbox") {
          @for (opt of field?.options; track opt) {
            <div
              class="cursor-pointer form-check m-2"
              (click)="selectCheckBox(field, opt.key)"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="field.value.includes(opt.key)"
              />
              {{ opt.key }}
            </div>
            @if (
              opt?.selectSubOptions?.length && field.value.includes(opt.key)
            ) {
              @for (subField of opt?.selectSubOptions; track subField) {
                <div class="nested-prompt">
                  <ng-template
                    *ngTemplateOutlet="
                      formTemplate;
                      context: { value: subField }
                    "
                  ></ng-template>
                </div>
              }
            }
          }
          @if (field.allowedSelections > 1) {
            <div class="small-font float-end">
              Choose up to {{ field.allowedSelections }}
            </div>
          }
        }
      }
    </div>
  }
</ng-template>
